import './style.css'
import './loading.css'
import ReactDOM from 'react-dom/client'
import { StrictMode, useState, useEffect } from 'react'
import { Leva } from 'leva'
import PortfolioCanvas from './PortfolioCanvas'
import PortfolioSections from './PortfolioSections'
import LoadingScreen from './components/LoadingScreen'
import { isMobile } from './Utils'

const root = ReactDOM.createRoot(document.querySelector('#root'))

function App() {
    const [isShowingLoadingScreen, setIsShowingLoadingScreen] = useState(true)
    const [loadingInfo, setLoadingInfo] = useState({ progress: 0, text: 'Loading videos...', assetsLoaded: false })

    const handleLoadingScreenProgressUpdate = (progress, text) => {
        setLoadingInfo(prev => ({ ...prev, progress, text }))
    }

    const handleAssetsLoaded = () => {
        setLoadingInfo(prev => ({ ...prev, assetsLoaded: true }))
        setIsShowingLoadingScreen(false)
    }

    useEffect(() => {
        const loadingContent = document.querySelector('.loading-content')
        loadingContent.classList.remove('hidden')
    }, [])

    return (
        <StrictMode>
            {isMobile() ? <Leva hidden /> : <Leva collapsed />}

            <LoadingScreen loadingInfo={loadingInfo} />

            <div id='canvas-container'>
                <PortfolioCanvas
                    onLoadingScreenProgressUpdate={handleLoadingScreenProgressUpdate}
                    onAssetsLoaded={handleAssetsLoaded}
                />
            </div>

            <div id="overlay-container" />

            {loadingInfo.assetsLoaded && (
                <PortfolioSections
                    id="portfolio-sections-container"
                />
            )}
        </StrictMode>
    )
}

root.render(<App />)